import { Box, Button } from "@mui/material";
import { useMemo, useState } from "react";
import DialogHeader from "@entrilia/shared/components/dialog/DialogHeader.tsx";
import PromptDialog from "@entrilia/shared/components/dialog/PromptDialog.tsx";
import DialogButtons from "@entrilia/shared/components/DialogButtons.tsx";
import type { ClientInfoExtended, ReportTemplate } from "../../../../../api/types/svTypes.ts";
import DataSource from "./DataSources.tsx";

interface Props {
  template: ReportTemplate;
  companies: ClientInfoExtended[];
  onClose: () => void;
  onRun: () => void;
  getEditReportTemplateUrl: (organization: string, dataSource: string, templateId: string) => string;
}

export default function RunWithCompanyDialog({ onClose, getEditReportTemplateUrl, template, onRun, companies }: Props) {
  const [selectedDataSource, setSelectedDataSource] = useState<string>(() => companies[0]?.clientCode || "");

  const templateUrl = useMemo(() => {
    if (!selectedDataSource) return "";
    return getEditReportTemplateUrl(template.organization, selectedDataSource, template.reportId);
  }, [template.organization, getEditReportTemplateUrl, selectedDataSource, template.reportId]);

  return (
    <PromptDialog open={true} sx={{ width: 517, minHeight: 215 }}>
      <DialogHeader text="Select Data Source" onClose={onClose} />
      <Box sx={{ pt: 1, px: 3, pb: 2.5 }}>
        <DataSource
          title={undefined}
          disclaimer="Select the company whose data you want to use."
          dataSource={selectedDataSource}
          companies={companies}
          onChange={(ds) => setSelectedDataSource(ds)}
        />
      </Box>
      <DialogButtons onCancel={onClose}>
        <Button href={templateUrl} target="_blank" variant="contained" disabled={!templateUrl} onClick={onRun}>
          Run
        </Button>
      </DialogButtons>
    </PromptDialog>
  );
}
